export default {
  excursion_conflict_message: `This excursion has been modified externally. Please refresh your browser and try again.`
};
